import { ClientDto, ClientType, IClientDto } from '../../api/ClientApi';
import { RootState } from '../reducers';

export function getClientForSiteForm(state: RootState): IClientDto | null {
    return state.site.client;
}

export function getClient(state: RootState): IClientDto | null {
    return state.clientForm.client;
}

export function getSuppliers(state: RootState): ClientDto[] | null {
    return state.clients.clients?.filter((c) => c.clientType === ClientType.Supplier) ?? null;
}

export function getCustomers(state: RootState): ClientDto[] | null {
    return state.clients.clients?.filter((c) => c.clientType === ClientType.Customer) ?? null;
}
